import React from 'react'
import BeerShareMenu from './BeerShareMenu.js'
import './beer.css'
import Triangle from '../images/triangle.png'
import { useEffect, useState } from 'react'


export default function Beer({
    isJustLoaded,
    shouldRender,
    theme,
    darkColor,
    fontMapBold,
    headerText,
    wineData,
    fontMapReg,
    bodyText,
    imageBase,
    imageType,
    matches,
    tastingText,
    userFlavorData,
    userAcidity,
    barColor,
    userSweetness,
    lightColor,
    wineFlavors,
    qrData,
    iconQRIMGID,
    QR,
    Share,
    beerData, 
    beerOwner, 
    userBeerFlavorData,
    beerProfile,
    beerCarbonation,
    beerBody, 
    beerBitterness,
    beerSweetness,
    beerDryness, 
    beerQRData, 
    menuOpen,
    setMenuOpen, 
    sparklingTheme, 
    beerTheme}) {

        
        const [breweryLogo, setBreweryLogo] = useState('');
        const [beerFlavors, setBeerFlavors] = useState([]);
        const [beerMatches, setBeerMatches] = useState(0);
        const intBodyText = parseInt(bodyText, 10);
        const beerProfileBitterness = beerProfile?.data?.bitter
        const beerProfileSweetness = beerProfile?.data?.sweet
        const beerProfileDryness = beerProfile?.data?.dry
    
        const beerProfileCarbonation = beerProfile?.data?.carbonation ? Math.round(beerProfile?.data?.carbonation * 100) : 0;
        const beerProfileBody = beerProfile?.data?.body ? Math.round(beerProfile?.data?.body * 100) : 0;

        const RADIUS = 7;

        const points = {
            bitter: { x: 50, y: 1},
            sweet: { x: 1, y: 99 },
            dry: { x: 99, y: 99 },
        };

        const centroidX = (points.bitter.x + points.sweet.x + points.dry.x) / 3;
        const centroidY = (points.bitter.y + points.sweet.y + points.dry.y) / 3;

    function pointInPolygon(px, py, poly) {
        let inside = false;
        for (let i = 0, j = poly.length - 1; i < poly.length; j = i++) {
        const xi = poly[i].x, yi = poly[i].y;
        const xj = poly[j].x, yj = poly[j].y;
        const intersect =
            ((yi > py) !== (yj > py)) &&
            (px < (xj - xi) * (py - yi) / (yj - yi) + xi);
        if (intersect) inside = !inside;
        }
        return inside;
    }

    function keepInsidePolygon(cx, cy, radius, poly) {
        let px = cx, py = cy;
        let safetyCounter = 0;
        while (!pointInPolygon(px, py, poly) && safetyCounter < 50) {
        px = px + (centroidX - px) * 0.05;
        py = py + (centroidY - py) * 0.05;
        safetyCounter++;
        }
        const shrinkFactor = 0.98;
        px = centroidX + (px - centroidX) * shrinkFactor;
        py = centroidY + (py - centroidY) * shrinkFactor;
        return { x: px, y: py };
    }

    function getDotPosition(bitter, sweet, dry) {
        const total = bitter + sweet + dry;
        const b = bitter / total;
        const s = sweet / total;
        const d = dry / total;
        let dotX = (b * points.bitter.x) + (s * points.sweet.x) + (d * points.dry.x);
        let dotY = (b * points.bitter.y) + (s * points.sweet.y) + (d * points.dry.y);
        return keepInsidePolygon(dotX, dotY, RADIUS, [
        points.bitter,
        points.dry,
        points.sweet
        ]);
    }

    const dot1 = getDotPosition(beerBitterness, beerSweetness, beerDryness);
    const dot2 = getDotPosition(beerProfileBitterness, beerProfileSweetness, beerProfileDryness);

   

    // Grab owner data
    useEffect(() => {
        
        if (!beerOwner) return; // Wait until beerOwner is set

        const fetchBeerOwner = async () => {
            try {
                const apiEndpoint = process.env.REACT_APP_OWNER;
                const authToken = process.env.REACT_APP_AUTH_TOKEN;

                const response = await fetch(apiEndpoint, {
                    method: 'GET',
                    headers: {
                        'Authorization': `Bearer ${authToken}`,
                        'Content-Type': 'application/json'
                    }
                });

            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }

            const ownerData = await response.json();
            console.log('Beer owner details:', ownerData);

            const currentOwner = ownerData.data.find(item => item.user_created === beerOwner);
            const logo = currentOwner.logo;
            setBreweryLogo(logo);
            // Store owner data in state if you have one
            // setBeerOwnerDetails(ownerData);

            } catch (error) {
            console.error('Error fetching beer owner details:', error);
        }

        console.log('beer profile:', beerProfile);

        if(beerProfile){
            const beerFlavorsRelationalEndPoint = process.env.REACT_APP_RELATIONAL_BEER_FLAVORS;
            const flavorIdsArray = beerProfile?.data?.flavors?.map(item => item);
            const flavorIdsString = flavorIdsArray.join(',');
            const authToken = process.env.REACT_APP_AUTH_TOKEN;

            //Fetch beer flavors
            const response = await fetch(`${beerFlavorsRelationalEndPoint}${flavorIdsString}`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${authToken}`,
                    'Content-Type': 'application/json'
                }
            });

            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }

            const flavorRelationalData = await response.json();
            console.log('Beer Flavor Data:', flavorRelationalData);
            
            const flavorIds = flavorRelationalData.data.map(item => item.Beer_Flavors_id);
            const flaveIdString= flavorIds.join(',');
            
            const flavorResponse = await fetch(`${process.env.REACT_APP_BEER_FLAVORS}${flaveIdString}`, {
                method: 'GET',
                headers: {
                     'Authorization': `Bearer ${authToken}`,
                    'Content-Type': 'application/json'
                }
            });
            if (!flavorResponse.ok) {
                throw new Error(`HTTP error! Status: ${flavorResponse.status}`);
            }

            const flavorData = await flavorResponse.json();
            setBeerFlavors(flavorData)
            console.log('Final Beer Flavor Data:', flavorData.data);

            // USER AND BEER FLAVOR MATCHES
            if (userBeerFlavorData?.data && flavorData?.data) {
                const beerFlavorNames = flavorData?.data?.map(f => f.name);
                const userFlavorNames = userBeerFlavorData?.data?.map(f => f.name);

                const matches = beerFlavorNames.filter(name => userFlavorNames.includes(name)).length;
                console.log(matches)
                setBeerMatches(matches);
                }
            }


    };
        fetchBeerOwner();
    }, [beerOwner]);



  return (
    <div>
        <div className={'top-div' }>
            <div className='beer-mobile-container'>
            {shouldRender && (
              <BeerShareMenu
                menuOpen={menuOpen}
                theme={theme}
                setMenuOpen={setMenuOpen}
                beerTheme={beerTheme}
              />
            )}
                <div className='top-section-container'>
                <div className='beer-title-container' style={{ backgroundColor: darkColor[theme] }}>
                    <div className='l-beer-title'>
                        <h1 className='beer-title' style={{ fontFamily: fontMapBold[headerText] }}>{beerData?.data?.name}</h1>
                        <p className="beer-year" style={{ fontFamily: fontMapReg[intBodyText] }}>{beerData?.data?.year}</p>
                    </div>
                    <div className='r-beer-title'>
                        <img src={`${imageBase}${breweryLogo}${imageType}`} className='brewery-logo'></img>
                        <img className='beer-image' src={`${imageBase}${beerData?.data?.bottle_image}${imageType}`} alt="Beer can" />
                    </div>
                </div>
                
                <div className='beer-content-div'>
                    <div className='beer-top-right' style={{ backgroundColor: darkColor[theme] }}>
                        <h2 className='my-profile-header-beer' style={{ fontFamily: fontMapBold[headerText] }}>My Tasting Profile</h2>
                        <p className="user-profile-beer" style={{ fontFamily: fontMapReg[intBodyText] }}>
                            {beerMatches === null || beerMatches === 0 ? tastingText.no_match_text : beerMatches === 1 || beerMatches === 2 ? tastingText.low_match_text
                            : tastingText.high_match_text}
                        </p>
                        <h3 className='beer-flavors-header' style={{ fontFamily: fontMapBold[headerText] }}>Flavors</h3>
                        <div className='main-beer-flave-container'>
                        <div className='beer-flavors-container top'>
                            {userBeerFlavorData?.data?.length > 0 ? (
                            userBeerFlavorData.data.slice(0, 3).map(item => (
                                <div className='beer-flavor-box' key={item.id}>
                                    <div
                                        className='beer-flav-img-container'
                                        style={{ backgroundColor: item.highlight_color }}
                                    >
                                        <img
                                        className='user-flavor-img'
                                        src={`${imageBase}${item.image}${imageType}`}
                                        alt={`Flavor ${item.Flavors_id}`}
                                        />
                                    </div>
                                    <p
                                        className='beer-flavor-title'
                                        style={{ fontFamily: fontMapReg[bodyText] }}
                                    >
                                        {item.name}
                                    </p>
                                </div>
                            ))
                                ) : (
                                <p>Loading flavors...</p>
                                )}
                            </div>
                        </div>
                        {userBeerFlavorData?.data?.length > 3 && (
                        <div className='beer-flavors-container bottom'>
                            {userBeerFlavorData?.data?.slice(3, 6).map(item => (
                                <div className='beer-flavor-box' key={item.id}>
                                    <div
                                    className='beer-flav-img-container'
                                    style={{ backgroundColor: item.highlight_color }}
                                    >
                                    <img
                                        className='user-flavor-img'
                                        src={`${imageBase}${item.image}${imageType}`}
                                        alt={`Flavor ${item.Flavors_id}`}
                                    />
                                    </div>
                                    <p
                                    className='beer-flavor-title'
                                    style={{ fontFamily: fontMapReg[bodyText] }}
                                    >
                                    {item.name}
                                    </p>
                                </div>
                                ))}
                        </div>
                        )}
                    </div>
                    <div className='beer-acid-sweetness-columns'>
                        <div className='acidity-col'>
                            <h4 className='beer-acidity-header' style={{ fontFamily: fontMapBold[bodyText] }}>Carbonation</h4>
                            <div className='beer-acidity-bar'>
                                <div style={{
                                    height: '50%',
                                    width: `${beerCarbonation}%`,
                                    backgroundColor: '#FBBD14',
                                    borderRadius: '15vw',
                                    marginLeft: '4%',
                                    marginRight: '4%',
                                    marginTop: '1%',
                                    marginBottom: '1%' 
                                }}>
                                </div>
                            </div>
                            <div className='acid-label-columns'>
                                <div className='l-acid-col-beer'>
                                    <p className='beer-low-lable' style={{ fontFamily: fontMapReg[bodyText] }}>Low</p>
                                </div>
                                <div className='r-acid-col-beer'>
                                    <p className='beer-high-lable lively-bubbles' style={{ fontFamily: fontMapReg[bodyText] }}>Lively Bubbles</p>
                                </div>
                            </div>
                        </div>
                        <div className='sweetness-col'>
                            <h4 className='beer-acidity-header' style={{ fontFamily: fontMapBold[bodyText] }}>Body</h4>
                            <div className='beer-sweetness-bar'>
                                <div style={{
                                    height: '50%',
                                    width: `${beerBody}%`,
                                    backgroundColor: '#FBBD14',
                                    borderRadius: '15vw',
                                    marginTop: '1%',
                                    marginBottom: '1%',
                                    marginLeft: '4%',
                                    marginRight: '4%'
                                }}>
                                </div>
                            </div>
                            <div className='acid-label-columns'>
                                <div className='l-acid-col-beer'>
                                    <p className='beer-low-lable' style={{ fontFamily: fontMapReg[bodyText] }}>Light</p>
                                </div>
                                <div className='r-acid-col-beer'>
                                    <p className='beer-high-lable lively-bubbles' style={{ fontFamily: fontMapReg[bodyText] }}>Full</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='triangle-section'>
                        <div className='triangle-container' style={{ borderBottomColor: darkColor[theme] }}>
                            <p className='bitter-text' style={{ fontFamily: fontMapReg[bodyText] }}>Bitter</p>
                            <svg
                                width="100%"
                                height="77%"
                                viewBox="0 0 100 102"
                                preserveAspectRatio="xMidYMid meet"
                            >
                            <polygon
                            points="50,1 99,99 1,99"
                            fill="white"
                            stroke="#E3B409"
                            strokeWidth="2.5"
                            />
                            <defs>
                            <radialGradient id="dotGradient1" cx="50%" cy="50%" r="50%">
                                <stop offset="0%" stopColor="#FFA500" stopOpacity="1" />
                                <stop offset="50%" stopColor="#FF69B4" stopOpacity="0.8" />
                                <stop offset="100%" stopColor="white" stopOpacity="0" />
                            </radialGradient>
                            </defs>
                            <circle cx={dot1.x} cy={dot1.y} r={RADIUS} fill="url(#dotGradient1)" />
                            </svg>
                            <p className='sweet-text' style={{ fontFamily: fontMapReg[bodyText] }}>Sweet</p>
                            <p className='dry-text' style={{ fontFamily: fontMapReg[bodyText] }}>Dry</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='bottom-section-container'>
                    <div className='beer-bottom-right' style={{ backgroundColor: lightColor[theme] }}>
                    <h2 className='beer-profile-header' style={{ fontFamily: fontMapBold[bodyText] }}>{beerData?.data?.name} Profile</h2>
                    <p className="user-profile-beer beer-description" style={{ fontFamily: fontMapReg[bodyText] }}>{beerProfile?.data?.description}</p>
                    <h3 className='beer-flavors-header' style={{ fontFamily: fontMapBold[bodyText] }}>Flavors</h3>
                    </div>
                    <div className='beer-flavors-container top'>
                        {beerFlavors?.data?.length > 0 ? (
                        beerFlavors?.data?.slice(0, 3).map(item => (
                            <div className='beer-flavor-box' key={item.id}>
                                <div
                                    className='beer-flav-img-container'
                                    style={{ backgroundColor: item.highlight_color }}
                                >
                                <img
                                className='user-flavor-img'
                                src={`${imageBase}${item.image}${imageType}`}
                                alt={`Flavor ${item.Flavors_id}`}
                                />
                            </div>
                                <p
                                className='beer-flavor-title'
                                style={{ fontFamily: fontMapReg[bodyText] }}
                                >
                                {item.name}
                                </p>
                            </div>
                            ))
                        ) : (
                            <p>Loading flavors...</p>
                        )}
                    </div>
                    {beerFlavors?.data?.length > 3 && (
                        <div className='beer-flavors-container bottom'>
                            {beerFlavors?.data?.slice(3, 6).map(item => (
                                <div className='beer-flavor-box' key={item.id}>
                                    <div
                                    className='beer-flav-img-container'
                                    style={{ backgroundColor: item.highlight_color }}
                                    >
                                    <img
                                    className='user-flavor-img'
                                    src={`${imageBase}${item.image}${imageType}`}
                                    alt={`Flavor ${item.Flavors_id}`}
                                    />
                                </div>
                                    <p
                                    className='beer-flavor-title'
                                    style={{ fontFamily: fontMapReg[bodyText] }}
                                    >
                                    {item.name}
                                    </p>
                                </div>
                            ))}
                        </div>
                    )}        
                </div>
                <div className='beer-acid-sweetness-columns-bottom'>
                    <div className='acidity-col'>
                        <h4 className='beer-acidity-header' style={{ fontFamily: fontMapBold[bodyText] }}>Carbonation</h4>
                        <div className='beer-acidity-bar'>
                            <div style={{
                                height: '50%',
                                width: `${beerProfileCarbonation}%`,
                                backgroundColor: '#FBBD14',
                                borderRadius: '15vw',
                                marginLeft: '4%',
                                marginRight: '4%'
                            }}>
                            </div>
                        </div>
                        <div className='acid-label-columns'>
                            <div className='l-acid-col-beer'>
                                <p className='beer-low-lable' style={{ fontFamily: fontMapReg[bodyText] }}>Flat</p>
                            </div>
                            <div className='r-acid-col-beer'>
                                <p className='beer-high-lable lively-bubbles' style={{ fontFamily: fontMapReg[bodyText] }}>Lively Bubbles</p>
                            </div>
                        </div>
                    </div>
                    <div className='sweetness-col'>
                        <h4 className='beer-acidity-header' style={{ fontFamily: fontMapBold[bodyText] }}>Body</h4>
                        <div className='beer-sweetness-bar'>
                            <div style={{
                                height: '50%',
                                width: `${beerProfileBody}%`,
                                backgroundColor: '#FBBD14',
                                borderRadius: '15vw',
                                marginLeft: '4%',
                                marginRight: '4%'
                            }}>
                            </div>
                        </div>
                        <div className='acid-label-columns'>
                            <div className='l-acid-col-beer'>
                                <p className='beer-low-lable' style={{ fontFamily: fontMapReg[bodyText] }}>Light</p>
                            </div>
                            <div className='r-acid-col-beer'>
                                <p className='beer-high-lable lively-bubbles' style={{ fontFamily: fontMapReg[bodyText] }}>Full</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='triangle-section bottom-triangle-sect'>
                    <div className='triangle-container' style={{ borderBottomColor: darkColor[theme] }}>
                            <p className='bitter-text' style={{ fontFamily: fontMapReg[bodyText] }}>Bitter</p>
                            <svg
                                width="100%"
                                height="77%"
                                viewBox="0 0 100 102"
                                preserveAspectRatio="xMidYMid meet"
                            >
                            <polygon
                            points="50,1 99,99 1,99"
                            fill="white"
                            stroke="#E3B409"
                            strokeWidth="2.5"
                            />
                            <defs>
                            <radialGradient id="dotGradient2" cx="50%" cy="50%" r="50%">
                                <stop offset="0%" stopColor="#FFA500" stopOpacity="1" />
                                <stop offset="50%" stopColor="#FF69B4" stopOpacity="0.8" />
                                <stop offset="100%" stopColor="white" stopOpacity="0" />
                            </radialGradient>
                            </defs>
                            <circle cx={dot2.x} cy={dot2.y} r={RADIUS} fill="url(#dotGradient2)" />
                        </svg>
                        <p className='sweet-text' style={{ fontFamily: fontMapReg[bodyText] }}>Sweet</p>
                        <p className='dry-text' style={{ fontFamily: fontMapReg[bodyText] }}>Dry</p>
                    </div>
                </div>
                <div className='beer-qr-code-section' style={{ backgroundColor: lightColor[theme] }} >
                    <button className='share-link' onClick={() => setMenuOpen(true)}>
                    <img className='share-img' alt='share-icon' src={Share}></img>
                    <p className='share-lable' style={{ fontFamily: fontMapReg[headerText] }}>Share your <br />Experience</p>
                    </button>
                    {beerQRData?.data.map((item, index) => {
                    const iconId = iconQRIMGID?.[index]; // Get the corresponding image ID

                    const imageSrc = iconId
                        ? `${process.env.REACT_APP_IMAGE_ENDPOINT}${iconId}${process.env.REACT_APP_IMAGE_TYPE}`
                        : QR; // Use QR as fallback

                    return (
                        <button
                        className='share-link'
                        key={item.id}
                        onClick={() => window.open(item.url, '_blank', 'noopener,noreferrer')}
                        >
                        <img
                            className='share-img'
                            src={imageSrc}
                            alt={`Flavor ${item.Flavors_id}`}
                        />
                        <p className='share-lable'>{item.label}</p>
                        </button>
                    );
                    })}
                </div>
            </div>
    


            <div className="beer-desktop-container">
                 <div className='large-beer-container'>
                    <img className='beer-img' alt='Beer Bottle' src={`${imageBase}${beerData?.data?.bottle_image}${imageType}`}></img>
                </div>
                <div className='beer-header' style={{ backgroundColor: darkColor[theme] }}>
                    <div className='qr-code-section'>
                        <button
                            onClick={() => setMenuOpen(true)}
                            className='share-link'
                        >
                            <img className='share-img' alt='share-icon' src={Share}></img>
                            <p className='share-lable'>Share your <br />Experience</p>
                        </button>
                        {beerQRData?.data.map((item, index) => {
                            const iconId = iconQRIMGID?.[index]; // Get the corresponding image ID
                            const imageSrc = iconId
                                ? `${process.env.REACT_APP_IMAGE_ENDPOINT}${iconId}${process.env.REACT_APP_IMAGE_TYPE}`
                                : QR; // Use QR as fallback
                            return (
                                <button
                                    className='share-link'
                                    key={item.id}
                                    onClick={() => window.open(item.url, '_blank', 'noopener,noreferrer')}
                                >
                                    <img
                                    className='share-img'
                                    src={imageSrc}
                                    alt={`Flavor ${item.Flavors_id}`}
                                    />
                                    <p className='share-lable'>{item.label}</p>
                                </button>
                            );
                        })}
                    </div>
                    <div className='logo-desk-container'>
                        <img
                            src={`${imageBase}${breweryLogo}${imageType}`}
                            className='brewery-logo'
                            alt='Brewery Logo'
                        ></img>
                    </div>
                </div>
                {shouldRender && (
                    <BeerShareMenu
                        menuOpen={menuOpen}
                        theme={theme}
                        setMenuOpen={setMenuOpen}
                        beerTheme={beerTheme}
                    />
                )}
                <div className='beer-content' style={{ backgroundColor: lightColor[theme] }}>
                    <div className='beer-name-div'>
                        <h1 className='beer-title'>{beerData?.data.name} <span className='beer-year'>{beerData?.data.year}</span></h1>
                    </div>
                    <div className='beer-flavor-columns'>
                        <div className='beer-l-col'>
                            <div className='beer-profile-container'>
                                <h2 className='my-profile-header'>My Tasting Profile</h2>
                                <p className="beer-user-profile" style={{ fontFamily: fontMapReg[intBodyText] }}>
                                    {beerMatches === null || beerMatches === 0 ? tastingText.no_match_text : beerMatches === 1 || beerMatches === 2 ? tastingText.low_match_text
                                    : tastingText.high_match_text}
                                </p>
                            </div>
                        <h3 className='beer-flavors-header'>Flavors</h3>
                        <div className='beer-flavors-container top'>
                            {userBeerFlavorData?.data?.map(item => (
                            <div className='flavor-box' >
                                <div className='flav-img-container' style={{ backgroundColor: item.highlight_color }}>
                                <img
                                    className='user-flavor-img'
                                    key={item.id}
                                    src={`${imageBase}${item.image}${imageType}`}
                                    alt={`Flavor ${item.Flavors_id}`}
                                />
                                </div>
                                <p className='flavor-title'>{item.name}</p>
                            </div>
                            ))}
                        </div>
                        <div className='carb-triangle-container'>
                        <div className='beer-acid-sweetness-columns'>
                            <div className='beer-carbonation-col'>
                                <h4 className='carbonation-header'>Carbonation</h4>
                                <div className='carbonation-bar'>
                                    <div style={{
                                        height: '50%',
                                        width: `${beerCarbonation}%`,
                                        backgroundColor: '#FBBD14',
                                        borderRadius: '15vw',
                                        marginLeft: '3%',
                                        marginRight: '3%',
                                    }}></div>
                                </div>
                                <div className='carbonation-label-columns'>
                                    <div className='l-flat-col'>
                                        <p className='flat-lable'>Flat</p>
                                    </div>
                                    <div className='r-lively-col'>
                                        <p className='lively-lable'>Lively Bubbles</p>
                                    </div>
                                </div>
                        </div>
                        <div className='beer-body-col'>
                            <h4 className='body-header'>Body</h4>
                            <div className='body-bar'>
                                <div style={{
                                  height: '50%',
                                  width: `${beerBody}%`,
                                  backgroundColor: '#FBBD14',
                                  borderRadius: '15vw',
                                  marginLeft: '3%',
                                  marginRight: '3%'
                                }}>
                                </div>
                            </div>
                        <div className='body-label-columns'>
                            <div className='l-acid-col'>
                                <p className='dry-label'>Light</p>
                            </div>
                            <div className='r-acid-col'>
                                <p className='sweet-label'>Full</p>
                            </div>
                        </div>
                     </div>
                     </div>
                     <div className='triangle-section'>
                        <div className='triangle-container' style={{ borderBottomColor: darkColor[theme] }}>
                            <p className='bitter-text' style={{ fontFamily: fontMapReg[bodyText] }}>Bitter</p>
                            <svg
                                width="100%"
                                height="80%"
                                viewBox="0 0 100 102"
                                preserveAspectRatio="xMidYMid meet"
                            >
                            <polygon
                            points="50,1 99,99 1,99"
                            fill="white"
                            stroke="#E3B409"
                            strokeWidth="2"
                            />
                            <defs>
                            <radialGradient id="dotGradient1" cx="50%" cy="50%" r="50%">
                                <stop offset="0%" stopColor="#FFA500" stopOpacity="1" />
                                <stop offset="50%" stopColor="#FF69B4" stopOpacity="1" />
                                <stop offset="100%" stopColor="white" stopOpacity=".8" />
                            </radialGradient>
                            </defs>
                            <circle cx={dot1.x} cy={dot1.y} r={RADIUS / 1.2} fill="orange" />
                            </svg>
                            <p className='sweet-text' style={{ fontFamily: fontMapReg[bodyText] }}>Sweet</p>
                            <p className='dry-text' style={{ fontFamily: fontMapReg[bodyText] }}>Dry</p>
                            </div>
                        </div>
                   </div>
                    </div>
                    <div className='beer-profile-col'>
                        <div className='beer-profile-container'>
                            <h2 className='my-profile-header'>{beerData?.data?.name} Profile</h2>
                            <p className="beer-user-profile">{beerProfile?.data?.description}</p>
                        </div>
                        <h3 className='beer-flavors-header'>Flavors</h3>
                         <div className='beer-flavors-container '>
                            {beerFlavors?.data?.map(item => (
                            <div className='flavor-box' >
                                <div className='flav-img-container' style={{ backgroundColor: item.highlight_color }}>
                                <img
                                    className='user-flavor-img'
                                    key={item.id}
                                    src={`${imageBase}${item.image}${imageType}`}
                                    alt={`Flavor ${item.Flavors_id}`}
                                />
                                </div>
                                <p className='flavor-title'>{item.name}</p>
                            </div>
                            ))}
                        </div>
                        <div className='carb-triangle-container'>
                        <div className='beer-acid-sweetness-columns'>
                            <div className='beer-carbonation-col'>
                                <h4 className='carbonation-header'>Carbonation</h4>
                                <div className='carbonation-bar'>
                                    <div style={{
                                        height: '50%',
                                        width: `${beerProfileCarbonation}%`,
                                        backgroundColor: '#FBBD14',
                                        borderRadius: '15vw',
                                        marginLeft: '3%',
                                        marginRight: '3%',
                                    }}></div>
                                </div>
                                <div className='carbonation-label-columns'>
                                    <div className='l-flat-col'>
                                        <p className='flat-lable'>Flat</p>
                                    </div>
                                    <div className='r-lively-col'>
                                        <p className='lively-lable'>Lively Bubbles</p>
                                    </div>
                                </div>
                        </div>
                        <div className='beer-body-col'>
                            <h4 className='body-header'>Body</h4>
                            <div className='body-bar'>
                                <div style={{
                                  height: '50%',
                                  width: `${beerProfileBody}%`,
                                  backgroundColor: '#FBBD14',
                                  borderRadius: '15vw',
                                  marginLeft: '3%',
                                  marginRight: '3%'
                                }}>
                                </div>
                            </div>
                        <div className='body-label-columns'>
                            <div className='l-acid-col'>
                                <p className='dry-label'>Light</p>
                            </div>
                            <div className='r-acid-col'>
                                <p className='sweet-label'>Full</p>
                            </div>
                        </div>
                     </div>
                     </div>
                     <div className='triangle-section'>
                        <div className='triangle-container' style={{ borderBottomColor: darkColor[theme] }}>
                            <p className='bitter-text' style={{ fontFamily: fontMapReg[bodyText] }}>Bitter</p>
                            <svg
                                width="100%"
                                height="80%"
                                viewBox="0 0 100 102"
                                preserveAspectRatio="xMidYMid meet"
                            >
                            <polygon
                            points="50,1 99,99 1,99"
                            fill="white"
                            stroke="#E3B409"
                            strokeWidth="2"
                            />
                            <defs>
                            <radialGradient id="dotGradient1" cx="50%" cy="50%" r="50%">
                                <stop offset="0%" stopColor="#FFA500" stopOpacity="1" />
                                <stop offset="50%" stopColor="#FF69B4" stopOpacity="1" />
                                <stop offset="100%" stopColor="white" stopOpacity=".8" />
                            </radialGradient>
                            </defs>
                            <circle cx={dot2.x} cy={dot2.y} r={RADIUS / 1.2} fill="orange" />
                            </svg>
                            <p className='sweet-text' style={{ fontFamily: fontMapReg[bodyText] }}>Sweet</p>
                            <p className='dry-text' style={{ fontFamily: fontMapReg[bodyText] }}>Dry</p>
                            </div>
                        </div>
                   </div>
                    </div>
                    
                    
                   </div> 
                    
                </div>
            </div>
        </div>
    </div>
  )
}
